import type { CalendarsUnionType } from 'owa-graph-schema';
import { getStore } from '../store/store';

export function getCalendarEntryForCategories(smtpAddress: string): CalendarsUnionType | undefined {
    return getStore().eligibleCalendars.get(smtpAddress);
}
